import "./Contact.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import CanalesDeAtenciN from "./sections/CanalesDeAtenciN";
import FormularioDeCotizaciN from "./sections/FormularioDeCotizaciN";
import NuestraUbicaciN from "./sections/NuestraUbicaciN";
import InformaciNCorporativa from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <NavegaciNPrincipal />
      <CanalesDeAtenciN />
      <FormularioDeCotizaciN />
      <NuestraUbicaciN />
      <InformaciNCorporativa />
    </div>;
}